var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnvelop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1M5.831 9.773l-3 2.182a.56.56 0 0 1-.785-.124.563.563 0 0 1 .124-.786l3-2.182a.563.563 0 0 1 .662.91zm8.124 2.058a.563.563 0 0 1-.785.124l-3-2.182a.563.563 0 0 1 .662-.91l3 2.182a.563.563 0 0 1 .124.786zm-.124-6.876-5.5 4a.56.56 0 0 1-.662 0l-5.5-4a.563.563 0 0 1 .662-.91L8 7.804l5.169-3.759a.563.563 0 0 1 .662.91"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnvelop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/envelop.svg";